import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("{{#if this.showContent}}\n  {{yield}}\n{{/if}}", {
  moduleName: "@dashboard/shared-ui/components/saas/feature-gate.hbs"
});